// src/i18n/es/hotels.ts

const hotels = {
  name: 'Instalación |||| Instalaciones',
  
  fields: {
    id: 'ID',
    name: 'Nombre',
    groupId: 'Grupo',
    groupName: 'Grupo',
    directoryId: 'Establecimiento del registro',
    registry: 'Registro',
    address: 'Dirección',
    city: 'Ciudad',
    country: 'País',
    postalCode: 'Código Postal',
    deviceCount: 'Dispositivos',
    activeDevices: 'Dispositivos Activos',
    analyticsEnabled: 'Insight Habilitado',
    source: 'Origen',
    isActive: 'Activo',
    createdAt: 'Fecha de Creación',
    updatedAt: 'Última Actualización',
    checkInsToday: 'Check-ins Hoy',
    checkInsThisWeek: 'Check-ins Esta Semana',
    checkInsThisMonth: 'Check-ins Este Mes',
  },

  hints: {
    groupOptional: 'Deje el grupo vacío para una instalación independiente.',
  },

  actions: {
    create: 'Crear Instalación',
    edit: 'Editar Instalación',
    delete: 'Eliminar Instalación',
    view: 'Ver Instalación',
    list: 'Lista de Instalaciones',
    viewStats: 'Ver Estadísticas',
    forceDelete: 'Eliminar Permanentemente',
    forceDeleteConfirm: 'Eliminar Definitivamente',
    confirmForceDelete: 'Eliminar Definitivamente',
  },
  
  messages: {
    create_success: 'Instalación creada correctamente',
    create_error: 'Error al crear la instalación',
    update_success: 'Instalación actualizada correctamente',
    update_error: 'Error al actualizar la instalación',
    delete_success: 'Instalación eliminada correctamente',
    delete_error: 'Error al eliminar la instalación',
    delete_confirm: '¿Está seguro de que desea eliminar esta instalación?',
    delete_with_devices: 'No se puede eliminar una instalación con dispositivos registrados',
    delete_with_checkins: 'No se puede eliminar una instalación con check-ins recientes (últimos 30 días)',
    no_hotels: 'No hay instalaciones disponibles',
    loading: 'Cargando instalaciones...',
    group_not_found: 'Grupo no encontrado',
    // Force delete messages
    force_delete_warning_short: 'Eliminar instalación y todos sus datos',
    forceDeleteCaption: 'Eliminar instalación y todos sus datos',
    forceDeleteConfirm: 'Eliminar Instalación Permanentemente',
    forceDeleteDanger: 'Esta acción es IRREVERSIBLE y eliminará TODOS los datos permanentemente.',
    forceDeleteWarning: '¿Está seguro de que desea eliminar permanentemente la instalación "%{hotelName}" y TODOS sus datos asociados?',
    forceDeleteWillRemove: 'Esto eliminará permanentemente',
    forceDeleteComplete: 'La instalación y todos sus datos asociados han sido eliminados permanentemente.',
    forceDeleteSummary: 'Resumen de eliminación',
    forceDeleteSuccess: 'Instalación eliminada permanentemente',
    forceDeleteError: 'Error al eliminar la instalación',
    allDevices: 'Todos los dispositivos',
    allJourneys: 'Todos los journeys de check-in',
    allEvents: 'Todos los eventos y errores',
    theHotel: 'La instalación en sí',
    deletedDevices: 'Dispositivos eliminados',
    deletedJourneys: 'Journeys eliminados',
    deletedEvents: 'Eventos eliminados',
    deletedHotels: 'Instalaciones eliminadas',
    // Force delete dialog
    force_delete_confirm: 'Eliminar Instalación Permanentemente',
    force_delete_warning: 'Esta acción es IRREVERSIBLE y eliminará TODOS los datos asociados con esta instalación.',
    force_delete_description: '¿Está seguro de que desea eliminar permanentemente la instalación "%{name}" y TODOS sus datos asociados?',
    force_delete_will_remove: 'Esto eliminará permanentemente',
    force_delete_item_devices: '%{count} dispositivo |||| %{count} dispositivos',
    force_delete_item_journeys: 'Todos los journeys de check-in',
    force_delete_item_events: 'Todos los eventos y errores',
    force_delete_item_config: 'Configuración de la instalación',
    force_delete_completed: 'La instalación y todos sus datos asociados han sido eliminados permanentemente.',
  },
  
  validation: {
    name_required: 'El nombre de la instalación es obligatorio',
    name_min_length: 'El nombre de la instalación debe tener al menos 3 caracteres',
    name_max_length: 'El nombre de la instalación no puede exceder 100 caracteres',
    address_max_length: 'La dirección no puede exceder 200 caracteres',
    city_max_length: 'La ciudad no puede exceder 100 caracteres',
    country_max_length: 'El país no puede exceder 100 caracteres',
    postal_code_max_length: 'El código postal no puede exceder 20 caracteres',
    group_required: 'La selección de grupo es obligatoria',
  },
  
  list: {
    title: 'Instalaciones',
    empty: 'No se encontraron instalaciones',
    search: 'Buscar instalaciones...',
  },
  
  show: {
    title: 'Detalles de la Instalación',
    basic_info: 'Información Básica',
    location_info: 'Ubicación',
    devices_section: 'Dispositivos',
    statistics: 'Estadísticas',
    recent_activity: 'Actividad Reciente',
    no_devices: 'No hay dispositivos registrados para esta instalación',
    metadata: 'Metadatos',
  },
  
  create: {
    title: 'Crear Nueva Instalación',
    subtitle: 'Agregar una nueva instalación al sistema',
  },
  
  edit: {
    title: 'Editar Instalación',
    subtitle: 'Modificar información de la instalación',
  },
  
  source: {
    Manual: 'Manual',
    Updater: 'Auto-registrado',
  },
  
  stats: {
    title: 'Estadísticas de la Instalación',
    devices: 'Dispositivos',
    checkins: 'Check-ins',
    performance: 'Rendimiento',
    channels: 'Canales',
    average_time: 'Tiempo Promedio de Check-in',
    completion_rate: 'Tasa de Pre-check-in',
    auto_keys: 'Llaves Dispensadas Automáticamente',
  },
  
  notifier: {
    title: 'Configuración de Notificaciones',
    subtitle: 'Configura alertas de notificación y canales',
    sections: {
      summary: 'Resumen de Configuración',
      channels: 'Canales de Notificación',
    },
    fields: {
      apiKey: 'Clave API',
      accountName: 'Nombre de Cuenta',
      enabled: 'Habilitado',
      channelType: 'Tipo de Canal',
      recipients: 'Destinatarios',
      alertMappings: 'Mapeo de Alertas',
      templateId: 'ID de Plantilla',
      useCustomMessage: 'Usar Mensaje Personalizado',
      alertType: 'Tipo de Alerta',
      customSubject: 'Asunto Personalizado',
      customMessage: 'Mensaje Personalizado',
      template: 'Plantilla',
    },
    help: {
      apiKey: 'Introduzca su clave API del servicio de notificaciones',
      accountName: 'Introduzca el nombre de cuenta para el servicio de notificaciones',
    },
    actions: {
      add_channel: 'Añadir Canal',
      disable_all: 'Deshabilitar Todas las Alertas',
      save: 'Guardar Configuración',
      add: 'Añadir',
      add_mapping: 'Añadir Mapeo',
    },
    alertTypes: {
      DeviceOffline: 'Dispositivo Desconectado',
      HighErrorRate: 'Alta Tasa de Errores',
      LowCompletionRate: 'Baja Tasa de Finalización',
      SystemError: 'Error del Sistema',
    },
    placeholders: {
      recipient: 'Email',
      templateId: 'Introduzca ID de plantilla',
      email: 'Introduzca dirección de email',
      phone: 'Introduzca número de teléfono',
      selectTemplate: 'Seleccione una plantilla',
    },
    messages: {
      channels_count: '{{count}} canal(es) configurado(s), {{enabled}} activado(s)',
      credentials_configured: 'Las credenciales API están configuradas',
      credentials_missing: 'Por favor configura las credenciales API para habilitar las notificaciones',
      no_channels: 'No hay canales de notificación configurados',
      save_success: 'Configuración de notificaciones guardada correctamente',
      no_templates: 'No hay plantillas disponibles',
    },
  },
};

export default hotels;